import { useComponent } from './useComponent';
import { RootContainer } from './styled';
export function ESignRoot() {
    const component = useComponent();
    return <RootContainer>{component}</RootContainer>;
}
